import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CLUSTER_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { ClusterComponent } from './cluster/cluster.component';
import { ClusterDetailComponent } from './cluster-detail/cluster-detail.component';

const routes: Routes = [
  {
    path: `${CLUSTER_ROUTE}/:cluster_id`,
    component: ClusterDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: CLUSTER_ROUTE,
    component: ClusterComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClusterRoutingModule {}
